import { useState, useMemo, useCallback } from 'react';

export const useClientSideSort = (data = [], initialSortField = null, initialSortOrder = 0) => {
    const [sortState, setSortState] = useState({
        sortField: initialSortField,
        sortOrder: initialSortOrder
    });

    const onSort = useCallback((e) => {
        setSortState({
            sortField: e.sortField,
            sortOrder: e.sortOrder
        });
    }, []);

    const sortedData = useMemo(() => {
        if (!data || !Array.isArray(data)) return [];

        // Sıralama yoksa orijinal veriyi döndür
        if (!sortState.sortField || !sortState.sortOrder) return [...data];

        return [...data].sort((a, b) => {
            let value1 = a[sortState.sortField];
            let value2 = b[sortState.sortField];

            // Null/undefined değerleri kontrol et
            if (value1 == null && value2 == null) return 0;
            if (value1 == null) return 1;
            if (value2 == null) return -1;

            // Tarih alanları için özel kontrol
            if (sortState.sortField.includes('Date') || sortState.sortField.includes('date')) {
                const date1 = new Date(value1);
                const date2 = new Date(value2);
                return (date1 - date2) * sortState.sortOrder;
            }

            // Sayısal değerler için kontrol
            if (typeof value1 === 'number' && typeof value2 === 'number') {
                return (value1 - value2) * sortState.sortOrder;
            }

            // String değerler için kontrol (büyük/küçük harf duyarsız)
            const str1 = String(value1).toLowerCase();
            const str2 = String(value2).toLowerCase();
            const result = str1.localeCompare(str2, 'tr', { numeric: true });

            return result * sortState.sortOrder;
        });
    }, [data, sortState.sortField, sortState.sortOrder]);

    const clearSorting = useCallback(() => {
        setSortState({
            sortField: null,
            sortOrder: 0
        });
    }, []);

    return {
        sortedData,
        sortField: sortState.sortField,
        sortOrder: sortState.sortOrder,
        onSort,
        clearSorting
    };
};